import * as React from 'react';
import { Info, Text } from 'framework/components/ui';
import { prefixClassName } from 'framework/components/ui/_conf';
import './_style.scss';
import { i18n } from '../../../../../../i18n';
import { SupportedServiceType } from '../Event/Event.interfaces';

const clx = prefixClassName('gutter-tooltip');
const localePath = 'components.calendar.components.headerGutterTooltip';
const expressPath = 'components.calendar.events.template.express';

export const TooltipContents = ({
  hasInstacartTimeslot,
  hasOrphanedSlots,
  expressSlotsInfo,
}: {
  hasInstacartTimeslot: boolean;
  hasOrphanedSlots: boolean;
  expressSlotsInfo?: {
    hasExpressService: boolean;
    expressServices: SupportedServiceType[];
  };
}) => {
  return (
    <div className={`${clx}__key-wrapper`}>
      <Text tag="div" caption={`${localePath}.key`} className={`${clx}__header`} />
      <Text tag="div" caption={`${localePath}.pickup`} className={`${clx} ${clx}__Pickup`} />
      <Text tag="div" caption={`${localePath}.delivery`} className={`${clx} ${clx}__Delivery`} />
      {hasInstacartTimeslot && (
        <Text tag="div" caption={`${localePath}.instacart`} className={`${clx} ${clx}__Instacart`} />
      )}
      {expressSlotsInfo?.hasExpressService && 
        expressSlotsInfo?.expressServices?.map((service, index) => {
          const count: number = service.timeframeInMinutes / 60;
          return (
            <Text
              tag="div"
              key={`${service.identifier}-${index}`}
              caption={i18n.t(`${expressPath}.expressHours`, { count })} className={`${clx} ${clx}__Express${count}hr`}
            />
          );
        })
      }
      <Text tag="div" caption={`${localePath}.blocking`} className={`${clx} ${clx}__Blocked`} />
      <Text tag="div" caption={`${localePath}.closed`} className={`${clx} ${clx}__Closed`} />
      {hasOrphanedSlots && <Text tag="div" caption={`${localePath}.orphaned`} className={`${clx} ${clx}__Orphaned`} />}
    </div>
  );
};

const HeaderGutterTooltip = ({
  hasInstacartTimeslot,
  hasOrphanedSlots,
  expressSlotsInfo,
}: {
  hasInstacartTimeslot: boolean;
  hasOrphanedSlots: boolean;
  expressSlotsInfo?: {
    hasExpressService: boolean;
    expressServices: SupportedServiceType[];
  };
}) => {
  return (
    <div className={`${clx}__wrapper`}>
      <div className={`${clx}__key`}>
        <Text caption={`${localePath}.key`} />
        <Info
          showOnHover
          toolTipPosition="down-right"
          tooltipBody={
            <TooltipContents
              hasInstacartTimeslot={hasInstacartTimeslot}
              hasOrphanedSlots={hasOrphanedSlots}
              expressSlotsInfo={expressSlotsInfo}
            />
          }
        />
      </div>
      {expressSlotsInfo.hasExpressService && <div className={`${clx}__expressSlots`}>{`${i18n.t(`${localePath}.allDay`)}`}</div>}
    </div>
  );
};

export default HeaderGutterTooltip;
